import { createPinia } from 'pinia'
import PrimeVue from 'primevue/config'
import ToastService from 'primevue/toastservice'
import { createApp } from 'vue'
import App from './App.vue'
import { router } from './router'
import { klunkersPassThrough } from './theme/primevue'
import './theme/fonts'
import './theme/tokens.css'

const app = createApp(App)
app.use(createPinia())
app.use(router)
app.use(PrimeVue, { unstyled: true, pt: klunkersPassThrough })
app.use(ToastService)
app.mount('#app')
